import React, { useState, useEffect } from 'react';
import '../../styles/Scheduler.css';
import { addEvent, getEvents } from '../../services/api';

function Scheduler() {
  const [events, setEvents] = useState([]);
  const [newEvent, setNewEvent] = useState({ title: '', date: '' });
  const [view, setView] = useState('list');

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getEvents();
        setEvents(data);
      } catch (err) {
        console.error('Failed to fetch events:', err);
      }
    };
    fetchEvents();
  }, []);

  const handleAddEvent = async (e) => {
    e.preventDefault();
    try {
      const eventData = { ...newEvent };
      const response = await addEvent(eventData);
      setEvents([...events, { id: response.id, ...eventData }]);
      setNewEvent({ title: '', date: '' });
    } catch (err) {
      alert('Failed to add event. Please try again.');
    }
  };

  return (
    <div className="sp-scheduler">
      <h2 className="sp-scheduler-title">Schedule</h2>
      <div className="sp-scheduler-controls">
        <button className="sp-view-btn" onClick={() => setView('list')}>List View</button>
        <button className="sp-view-btn" onClick={() => setView('calendar')}>Calendar View</button>
      </div>
      <form className="sp-event-form" onSubmit={handleAddEvent}>
        <input
          className="sp-event-input"
          type="text"
          placeholder="Event title"
          value={newEvent.title}
          onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
          required
        />
        <input
          className="sp-event-input"
          type="date"
          value={newEvent.date}
          onChange={(e) => setNewEvent({ ...newEvent, date: e.target.value })}
          required
        />
        <button className="sp-event-btn" type="submit">Add Event</button>
      </form>
      {view === 'list' ? (
        <ul className="sp-event-list">
          {events.map((event) => (
            <li key={event.id} className="sp-event-item">
              {event.title} - {event.date}
            </li>
          ))}
        </ul>
      ) : (
        <div className="sp-calendar-view">
          <p>Calendar view coming soon...</p>
        </div>
      )}
    </div>
  );
}

export default Scheduler;